// extracted by mini-css-extract-plugin
export default {"overlay":"gt-z","bodyOpen":"ht-z","content":"it-z","header":"jt-z","close":"kt-z","closeNoHeading":"lt-z"};